<template lang="pug">
  .zepto-transactions
    v-row
      v-col
        v-row
          v-chip.my-auto.mx-2(small outlined rounded
                              class="text-uppercase my-auto button-AA-tiny"
                              :color="statusColor(transaction.status)"
                              :style="{ 'background-color': chipBackgroundColor(transaction.status) + '!important' }"
                              ) {{ transaction.status }}
        v-row.mt-3
          div.request-info.ma-2
            div.c1.basic800--text Shipping fee: {{ transaction.fee | displayPrice }}
            div.c1.basic800--text Pickup date: {{ transaction.pickup_date | displayDate }}
            div.c1.basic800--text Pickup time: {{ transaction.pickup_time | displayTime }}

        v-row.px-3.mt-3
          eva-icon(name="file-text-outline" height="16" :fill="$vuetify.theme.themes[$theme].basic600")
          a.text-decoration-none.c1.basic600--text.ml-2(@click="clickOpenReceipt") View receipt

        v-row.px-3(v-if="transaction.status !== 'error'")
          eva-icon(name="credit-card-outline" height="16" :fill="$vuetify.theme.themes[$theme].basic600")
          a.text-decoration-none.c1.basic600--text.ml-2(:href="transaction.zepto.bill_url" target="_blank") Payment Status

      v-col(cols="6")
        .job-details.body-2(v-if="transaction.zepto")
          div.c1.basic800--text # {{transaction.zepto.job_id}}
          div.c1.basic800--text Pickup code: {{ transaction.zepto.secret_code_pickup }}
          div.c1.basic800--text Delivery code: {{ transaction.zepto.secret_code_delivery }}
          div.c1.basic800--text Rider name: {{ transaction.zepto.rider_name }}
          div.c1.basic800--text Rider phone: {{ transaction.zepto.rider_phone }}
          div.c1.basic800--text Rider vehicle no: {{ transaction.zepto.rider_vehicle_no }}
          div.c1.basic800--text Accepted at: {{ transaction.zepto.accepted_datetime | convertServerDate }}
          div.c1.basic800--text Accepted at: {{ transaction.zepto.pickup_datetime | convertServerDate }}
          div.c1.basic800--text Delivered at: {{ transaction.zepto.delivered_datetime | convertServerDate }}

        .empty(v-else)
          div.c1.basic800--text No data available
          v-btn.mt-2(v-if="transaction.status == 'new' || transaction.status == 'error'"
                     x-small
                     class="button-AA-small white--text info500"
                     outlined height="26"
                     @click="clickShipItem()") ship to this address
    .modals
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead")
      ship-item(v-if="openShipItemDialog" :open.sync="openShipItemDialog" :lead.sync="lead")
</template>

<script>
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'
import ShipItem from '@/components/dialogs/order/ShipItem.vue'
export default {
  name: 'ZeptoTransaction',
  props: ['transaction'],
  components: { ProductInvoice, ShipItem },
  data: () => ({
    lead: null,
    openInvoiceDialog: false,
    openShipItemDialog: false
  }),
  methods: {
    clickOpenReceipt () {
      if (this.lead) {
        this.openInvoiceDialog = true
      } else {
        this.$axios.get(`/leads/${this.transaction.lead_pid}/`)
          .then((resp) => {
            this.lead = resp.data
            this.openInvoiceDialog = true
          })
          .catch(() => {})
      }
    },
    clickShipItem () {
      if (this.lead) {
        this.openShipItemDialog = true
      } else {
        this.$axios.get(`/leads/${this.transaction.lead_pid}/`)
          .then((resp) => {
            this.lead = resp.data
            this.openShipItemDialog = true
          })
          .catch(() => {})
      }
    },
    statusColor (status){
      switch(status){
        case 'delivered':
          return 'success500'
        case 'pending':
          return 'textColorAccent'
        case 'error':
          return 'danger500'
      }
    },
    chipBackgroundColor (status) {
      //-return paid ? theme.successT08 : theme.dangerT08
      const theme = this.$vuetify.theme.themes[this.$theme]
      switch(status){
        case 'delivered':
          return theme.successT08
        case 'pending':
          return theme.successT08
        case 'error':
          return theme.dangerT08
      }
    }

  }
}
</script>

<style scoped>
</style>